import { ToolsService } from '@/app/services/tools'
import { PaginatedQueryResponse } from '@/types/api'
import { IToolSuggestion } from '@/types/tool-suggestion'
import { useInfiniteQuery } from 'react-query'

const LIMIT = 5

export function useToolsSearch(q: string, enabled: boolean = true) {
  return useInfiniteQuery<PaginatedQueryResponse<IToolSuggestion>>(
    ['tools-search', q],
    ({ pageParam = 1 }) => ToolsService.searchTools(q, pageParam, LIMIT),
    {
      enabled,
      getNextPageParam: ({ metadata: { page, limit, total } }) =>
        page * limit < total ? page + 1 : undefined,
    }
  )
}
